import React, { useState, useEffect } from "react";
import { Row, Col, Button, Card, Table, ButtonGroup, Alert, ProgressBar, Badge, Tabs, Tab } from "react-bootstrap";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import Utils from "./../../common/Utils";

const AttnRequests = (props) => {
  
  const [teamRequests, setTeamRequests] = useState({
    loading: false,
    total: 0,
    start: 0,
    pp: Utils.perpage,
    records: [],
  });

  const [tab, setTab] = useState(1);
  const [expandedReasons, setExpandedReasons] = useState({});

  const toggleReason = (id) => {
    setExpandedReasons((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const fetchTeamRequests = (start = 0, currentTab = tab) => {
    setTeamRequests(prev => ({ ...prev, loading: true }));
    axios
      .get(Utils.apiUrl("attendence/fetchteamrequests") + `?tab=${currentTab}&st=${start}&pp=${teamRequests.pp || Utils.perpage}`, Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setTeamRequests({
            loading: false,
            pp: teamRequests.pp || Utils.perpage,
            start: start,
            total: _.get(data, "total", 0),
            records: _.get(data, 'records', []),
          });
        } else {
          setTeamRequests(prev => ({ ...prev, loading: false }));
        }
      })
      .catch((err) => {
        setTeamRequests(prev => ({ ...prev, loading: false }));
        console.log(err);
      });
  };

  useEffect(() => {
    fetchTeamRequests(0, tab);
  }, [tab, props.refreshTrigger]);

  const addressRequest = (rid, aid) => (e) => {
    if (window.confirm(`You are going to ${aid === 0 ? "Disapprove" : "Approve"} this request, Continue?`)) {
      setTeamRequests(prev => ({ ...prev, loading: true }));
      axios
        .post(Utils.apiUrl("attendence/updaterequest"), `rid=${rid}&aid=${aid}`, Utils.apiHeaders())
        .then((res) => {
          const data = Utils.parseApiResponse(res);
          if (data.success) {
            fetchTeamRequests(0, tab);
          } else {
            window.alert(data.message);
            setTeamRequests(prev => ({ ...prev, loading: false }));
          }
        })
        .catch((err) => {
          setTeamRequests(prev => ({ ...prev, loading: false }));
          console.log(err);
        });
    }
  };

  const showPagination = ({ loading, start, total, pp }, callback) => {
    if (loading || total <= pp) {
      return null;
    }
    const curPage = Math.floor(start / pp) + 1;
    const totalPages = Math.ceil(total / pp);
    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 border-top pt-3">
        <span className="small text-muted fw-semibold">
          Showing {start + 1} to {Math.min(start + pp, total)} of {total} requests
        </span>
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary rounded-pill px-3"
            onClick={() => callback(Math.max(0, start - pp), tab)}
            disabled={start === 0}
          >
            ← Previous
          </button>
          <span className="small fw-bold text-dark px-1">
            Page {curPage} of {totalPages}
          </span>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary rounded-pill px-3"
            onClick={() => callback(start + pp, tab)}
            disabled={start + pp >= total}
          >
            Next →
          </button>
        </div>
      </div>
    );
  };

  const renderReason = (rec) => {
    const reason = (rec.reason || "").trim();
    if (!reason) {
      return <span className="text-muted">—</span>;
    }
    if (reason.length <= 20) {
      return <span>{reason}</span>;
    }
    const isExpanded = !!expandedReasons[rec.id];
    return (
      <div style={{ maxWidth: isExpanded ? "360px" : "220px", whiteSpace: isExpanded ? "normal" : "nowrap" }}>
        <span>{isExpanded ? reason : `${reason.slice(0, 20)}...`}</span>
        <button
          type="button"
          className="btn btn-link btn-sm p-0 ms-1 text-primary fw-semibold"
          style={{ fontSize: "12px", textDecoration: "none", verticalAlign: "baseline", cursor: "pointer" }}
          onClick={() => toggleReason(rec.id)}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      </div>
    );
  };
  
  return (
    <section className="dt-card dt-card--flush mb-4">
      <div className="dt-card__head d-flex justify-content-between align-items-center" style={{ padding: "18px 20px 0", marginBottom: "12px" }}>
        <div>
          <h2 className="dt-card__title">My Team's Differed Attendance Requests</h2>
          <span className="text-muted small">Review and approve employee backdated &amp; differed hours</span>
        </div>
      </div>
      <div>
        {teamRequests.loading && (
          <div className="p-4 text-center">
            <ProgressBar animated now={100} variant="primary" style={{ height: "6px" }} />
            <p className="mt-2 text-muted small">Fetching Differed Attendance requests...</p>
          </div>
        )}
        {!teamRequests.loading && (
          <>
            <div className="px-3 pt-2">
              <Tabs activeKey={tab} onSelect={(k) => setTab(parseInt(k))} className="mb-3">
                <Tab eventKey="1" title="New Requests"></Tab>
                <Tab eventKey="2" title="Delete Requests"></Tab>
              </Tabs>
            </div>

            {teamRequests.records.length === 0 && (
              <div className="p-4 text-center text-muted">
                <div style={{ fontSize: "24px", marginBottom: "6px" }}>📋</div>
                <div className="fw-semibold">No Differed Attendance Requests Found</div>
              </div>
            )}

            {teamRequests.records.length > 0 && (
              <Table striped hover responsive className="dt-table m-0">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Applicant</th>
                    <th>Date</th>
                    <th>Duration</th>
                    <th>Type</th>
                    <th>Reason</th>
                    <th style={{ minWidth: "190px", whiteSpace: "nowrap" }} className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {teamRequests.records.map((rec, idx) => (
                    <tr key={rec.id}>
                      <td>
                        <span className="tb-lable tb-lable-warning">{Utils.addZero(teamRequests.start + idx + 1)}.</span>
                      </td>
                      <td><strong>{rec.uname}</strong></td>
                      <td>{moment(rec.logout).format("DD MMM, YY")}</td>
                      <td><span className="badge bg-light text-dark border">{rec.duration}</span></td>
                      <td><span className="badge bg-info text-white">{rec.diftype}</span></td>
                      <td>{renderReason(rec)}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <div className="d-flex align-items-center justify-content-center gap-2 flex-nowrap">
                          <button className="btn btn-sm btn-success rounded-pill px-3 text-nowrap" onClick={addressRequest(rec.id, 1)}>
                            Approve
                          </button>
                          <button className="btn btn-sm btn-outline-danger rounded-pill px-3 text-nowrap" onClick={addressRequest(rec.id, 0)}>
                            Disapprove
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
        <div className="p-3">
          {showPagination(teamRequests, fetchTeamRequests)}
        </div>
      </div>
    </section>
  ); 
};

export default AttnRequests;